/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrafficSource,
    TrafficSourceFromJSON,
    TrafficSourceFromJSONTyped,
    TrafficSourceToJSON,
} from './TrafficSource';

/**
 * 
 * @export
 * @interface OrderItemOrderCreateParamsV2
 */
export interface OrderItemOrderCreateParamsV2 {
    /**
     * A positive integer representing the number of instances of parent that are included in this order item. Applicable/present only if type is registration.
     * @type {number}
     * @memberof OrderItemOrderCreateParamsV2
     */
    quantity: number;
    /**
     * Identifer of the associated object for this line item.
     * @type {string}
     * @memberof OrderItemOrderCreateParamsV2
     */
    parent_id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemOrderCreateParamsV2
     */
    product_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemOrderCreateParamsV2
     */
    product_variation_id: string;
    /**
     * 
     * @type {TrafficSource}
     * @memberof OrderItemOrderCreateParamsV2
     */
    source?: TrafficSource;
}

export function OrderItemOrderCreateParamsV2FromJSON(json: any): OrderItemOrderCreateParamsV2 {
    return OrderItemOrderCreateParamsV2FromJSONTyped(json, false);
}

export function OrderItemOrderCreateParamsV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemOrderCreateParamsV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'parent_id': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'product_id': json['product_id'],
        'product_variation_id': json['product_variation_id'],
        'source': !exists(json, 'source') ? undefined : TrafficSourceFromJSON(json['source']),
    };
}

export function OrderItemOrderCreateParamsV2ToJSON(value?: OrderItemOrderCreateParamsV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantity': value.quantity,
        'parent_id': value.parent_id,
        'product_id': value.product_id,
        'product_variation_id': value.product_variation_id,
        'source': TrafficSourceToJSON(value.source),
    };
}

